import "./SubCategoryCard.scss";

import React from "react";
import { Category } from "shared/src/types/articlesearch/Category";
import { ImageWithFallback } from "./ImageWithFallback";
import { FormattedMessage } from "react-intl";
import { trackChooseSubCategoryPanel } from "../../../utils/SearchTrackingUtil";
import { SearchQuery } from "shared/src/types/articlesearch/SearchResult";

type SubCategoryCardProps = {
    category: Category;
    query: SearchQuery;
    queryLinkComponent: any;
};

const errorImagePath = "/ordercapture/uidispatcher/static/app/assets/images/placeholder_food_item.png?w=144&h=144";
export function SubCategoryCard(props: SubCategoryCardProps) {
    const QueryLinkComponent = props.queryLinkComponent;
    return (
        <QueryLinkComponent
            query={Object.assign({}, props.query, { categoryPath: props.category.urlCategoryPath })}
            key={props.category.categoryId || ""}
            onClick={() => {
                trackChooseSubCategoryPanel(props.category.name);
            }}>
            <div className="sd-subcategory-card col-md-4 col-sm-6">
                <div className="sd-subcategory-card-inner-container">
                    <div className="sd-subcategory-card-circular-image-container">
                        <ImageWithFallback
                            src={
                                props.category.imageUrl ? appendWidthAndHeightQueryParams(props.category.imageUrl) : ""
                            }
                            description={props.category.name}
                            className="sd-subcategory-card-image"
                            fallbackPath={errorImagePath}
                        />
                    </div>
                    <div className="sd-subcategory-card-text-container">
                        <div className="sd-subcategory-card-title">{props.category.name}</div>
                        <div className="sd-subcategory-card-count">
                            <FormattedMessage
                                id={"EX_SUBCATEGORY_ARTICLE_COUNT"}
                                values={{ count: props.category.amounts }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </QueryLinkComponent>
    );
}

function appendWidthAndHeightQueryParams(url: string) {
    const prefix = url.includes("?") ? "&" : "?";
    return url + prefix + "w=40&h=40";
}
